import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/Main';
import Cloud from '@/views/Courseware/index.vue';
import Auth from '@/views/Auth';
import MainChildrenRoutes from './main';
// // 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);


const router = new Router({
  mode: 'history',
  // mode: 'hash',

  routes: [
    {
      path: '/cloud',
      name: 'Cloud',
      component: Cloud,
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
    },
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: MainChildrenRoutes,
      meta: {
        title: '首页',
      },
    },
  ],
});

export default router;

/*
router.afterEach((to, from) => {
  if (to.name !== from.name && to.query.per_page && to.query.per_page != 10) {
    to.query.per_page = 10;

    router.replace({
      query: to.query
    })
  }
})
*/



// WEBPACK FOOTER //
// ./src/router/index.js